var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wl-progressbar",class:`bg-${_vm.variantBg}`},[_c('div',{staticClass:"wl-progressbar__progress",class:`bg-${_vm.variant}`,style:(_vm.barStyle)},[(_vm.progress > 0 && _vm.showCurrentValue)?_c('div',{staticClass:"wl-progressbar__counter"},[_vm._v(_vm._s(Math.round(_vm.currentvalue)))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }